import './SideBarLeft.css';
import { ButtonLink } from '../buttons/ButtonLink/ButtonLink';
import { Button } from '../buttons/Button/Button';
import { ButtonsForSideBar, LinksForSideBar, TypingForSideBar } from './constantsForSideBarLeft';

export const SideBarLeft = () => {
    return (
        <aside className="side-bar-left">
            <div className="side-bar-left__container">
                {LinksForSideBar.map((item, i) => (
                    <ButtonLink link={item.link} key={i} icon={item.icon} />
                ))}
            </div>

            <div className="side-bar-left__container-typing">
                {TypingForSideBar.map((item, i) => (
                    <Button link={item.link} key={i} icon={item.icon} />
                ))}
            </div>
            <div className="side-bar-left__container">
                {ButtonsForSideBar.map((item, i) => (
                    <Button link={item.link} key={i} icon={item.icon} />
                ))}
            </div>
        </aside>
    );
};
